<form [formGroup]="achRegistrationForm" class="ach-payment" (ngSubmit)="achPaymentsDetails()">
  @if (isFetching()) {
  <rs-loader></rs-loader>
  }
  <h4>Financial Institution Information</h4>
  <div class="row bank-info-content">
    <div class="left-content col-sm-6">
      <div><span class="field-label">Account Name</span><span>
          <rs-input validation="eager" formControlName="accountName" class="payment-inputs" [ariaLabel]="'Account Name'">
          </rs-input>
        </span>
      </div>
      <div><span class="field-label">Bank Name:</span><span>
          <rs-input validation="eager" formControlName="bankName" class="payment-inputs" [ariaLabel]="'Bank Name'">
          </rs-input>
        </span>
      </div>
      <div class="account-type">
        <h5 class="field-label">Account Type</h5>
        <span>
          <rs-radio id="1" name="accountType" label="Checking" value="Checking"
            (change)="onAccountTypeChange($event)"></rs-radio>
          <rs-radio id="2" name="accountType" label="Savings" value="Savings" (change)="onAccountTypeChange($event)">
          </rs-radio>
        </span>
      </div>
      <div><span class="field-label">Account Number:</span><span>
          <rs-input validation="eager" formControlName="accountNumber" class="payment-inputs" [ariaLabel]="'Account Number'">
          </rs-input>
        </span>
      </div>
      <div><span class="field-label">Re-type Account Number:</span><span>
          <rs-input validation="eager" formControlName="confirmAccountNumber" class="payment-inputs" [ariaLabel]="'Re-type Account Number'"></rs-input>
        </span>
      </div>
      <div><span class="field-label">Routing Number:</span><span>
          <rs-input validation="eager" formControlName="routingNumber" class="payment-inputs" [ariaLabel]="'Routing Number'">
          </rs-input>
        </span>
      </div>
      <div><span class="field-label">Re-type Routing Number:</span><span>
          <rs-input validation="eager" formControlName="confirmRoutingNumber" class="payment-inputs" [ariaLabel]="'Re-type Routing Number'"></rs-input>
        </span>
      </div>
    </div>
    <div class="right-content col-sm-6">
      <h5>Bank Address</h5>
      <div><span class="field-label">Address Line1:</span><span>
          <rs-input validation="eager" formControlName="line1" class="payment-inputs" [ariaLabel]="'Address Line1'">
          </rs-input>
        </span>
      </div>
      <div><span class="field-label">Address Line2::</span><span>
          <rs-input validation="eager" formControlName="line2" class="payment-inputs" [ariaLabel]="'Address Line2'">
          </rs-input>
        </span>
      </div>
      <div><span class="field-label">City:</span><span>
          <rs-input validation="eager" formControlName="city" class="payment-inputs" [ariaLabel]="'City'"></rs-input>
        </span>
      </div>
      <div><span class="field-label">State:</span><span>
          <rs-select [items]="dropDownStates()" [disabled]="disableStates()" class="payment-inputs" formControlName="state" [searchable]="true"
            validation="eager" [ariaLabel]="'State'">
          </rs-select>
        </span>
      </div>
      <div><span class="field-label">Country:</span><span>
          <rs-select [items]="dropDownCountries()" formControlName="country" class="payment-inputs" [searchable]="true"
            validation="eager" [ariaLabel]="'Country'">
          </rs-select>
        </span>
      </div>
      <div><span class="field-label">Zip:</span><span>
          <rs-input validation="eager" formControlName="zip" class="payment-inputs" [ariaLabel]="'Zip'"></rs-input>
        </span>
      </div>
    </div>
  </div>
  <h4>Requester Information</h4>
  <div class="row details-row">
    <div class="col-sm-3">
      <rs-input validation="eager" formControlName="firstName" class="payment-inputs" label="First Name">
      </rs-input>
    </div>
    <div class="col-sm-3">
      <rs-input validation="eager" formControlName="lastName" class="payment-inputs" label="Last Name">
      </rs-input>
    </div>

    <div class="col-sm-3">
      <rs-input validation="eager" [mask]="phoneMask" formControlName="phoneNumber" class="payment-inputs" label="Phone Number:">
      </rs-input>
    </div>
    <div class="col-sm-3">

      <rs-input validation="eager" type="email" formControlName="emailAddress" class="create-user-inputs"
        label="Email Address:"></rs-input>
    </div>
  </div>
  <div class="row details-row">
    <div class="col-sm-3">
      <rs-input formControlName="effectiveDate" class="payment-inputs" type="date" strictDateTyping placeholder="MM/DD/YYYY"
        label="Effective Date" validation="eager" min="1900-01-01"></rs-input>
    </div>
  </div>
  <div class="row details-row">
    <div class="col submit">
      <button [disabled]="!achRegistrationForm.valid && !accountType()" rs-raised-button color="primary">Next</button>
    </div>
  </div>
</form>

<rs-dialog [visible]="showConfirmation() && (((achPaymentRegistrationDetails() | keyvalue)?.length ?? 0) > 0)" maxWidth="85%"
  (visibleChange)="dialogClose($event)" heading="Recurring Payment Setup - Authorization">
  <div class="recurring-payment">
  @if (isFetching()) {
    <rs-loader imageSrc={{loaderImage}}></rs-loader>
  }
  @if (achError()) {
  <div class="error-message">{{achError()}}</div>
  }
  @if (isRegistrationSuccess()) {
  <div class="success-message">Your request has been received. Thank you</div>
  }
  @if (achPaymentRegistrationDetails() && !isRegistrationSuccess()) {
  <div class="confirmation">
  <div class="notify-message" > For your records, please print this page prior to clicking ‘Submit’.</div>
    <div class="confirmation-content">
      <div class="group-details left-content">
        <div>
          <span class="summary-label">Business Unit</span>
          <span>{{achPaymentRegistrationDetails()?.payer}}</span>
        </div>
        <div>
          <span class="summary-label">Group Name</span>
          <span>{{achPaymentRegistrationDetails()?.groupName}}</span>
        </div>
        <div>
          <span class="summary-label">Group Number</span>
          <span>{{achPaymentRegistrationDetails()?.groupSpecifiedIdentifier}}</span>
        </div>
        <div>
          <span class="summary-label">Group Sub-Group Number(s)</span>
          <span>{{achPaymentRegistrationDetails()?.subgroupSpecifiedIdentifiers}}</span>
        </div>
        <div>
          <span class="summary-label">Name</span>
          <span>{{achPaymentRegistrationDetails()?.firstName}}</span>
          <span>{{achPaymentRegistrationDetails()?.lastName}}</span>
        </div>
        <div>
          <span class="summary-label">Phone Number</span>
          <span>{{phoneNumberFormat(achPaymentRegistrationDetails()?.phoneNumber)}}</span>
        </div>

        <div>
          <span class="summary-label">Email</span>
          <span>{{achPaymentRegistrationDetails()?.emailAddress}}</span>
        </div>
      </div>
      <div class="banks-details right-content">
        <h4>Financial Institution Information</h4>
        <div>
          <span class="summary-label">Account Name</span>
          <span>{{achPaymentRegistrationDetails()?.bankAccountDetails?.nameOnAccount}}</span>
        </div>
        <div>
          <span class="summary-label">Bank Name</span>
          <span>{{achPaymentRegistrationDetails()?.bankAccountDetails?.bankName}}</span>
        </div>
        <div>
          <span class="summary-label">Bank Address</span>
          <span>{{achPaymentRegistrationDetails()?.bankAccountDetails?.address}}</span>
        </div>
        <div>
          <span class="summary-label">Account Number</span>
          <span>{{achPaymentRegistrationDetails()?.bankAccountDetails?.accountNumber}}</span>
        </div>
        <div>
          <span class="summary-label">Routing Number</span>
          <span>{{achPaymentRegistrationDetails()?.bankAccountDetails?.routingNumber}}</span>
        </div>
        <div>
          <span class="summary-label">Account Type</span>
          <span>{{achPaymentRegistrationDetails()?.bankAccountDetails?.accountType}}</span>
        </div>
      </div>
    </div>
    <div class="acknowledge">
      <ul><li>
      <rs-checkbox id="acknowledge" ariaLabel="I authorize recurring ACH payments" (change)="acknowledgeSelected($event)"></rs-checkbox>
      <span> Effective<span>{{achPaymentRegistrationDetails()?.effectiveDate | date:'MM/dd/yyyy'}}</span><span> I hereby authorize Delta Dental and its subsidiaries, affiliates,
        successors and assigns to initiate recurring automatic withdrawals (ACH) from the account indicated above in
        accordance with my underlying contract with Delta Dental and Delta Dental’s ACH processing policies for the
        payment of premium, admin fees, or claims reimbursement.
        I understand that I am responsible for any fees incurred due to the ACH being rejected or returned for any
        reason by my bank and collection action may be taken. This authorization will remain in full force and effect
        until Delta Dental has received written notification from me of its termination in such time as to afford Delta
        Dental and the Financial Institution a reasonable opportunity to act on it, or until all of my payment
        obligations under the contract have been satisfied. </span> </span></li>
        </ul>
        <ach-payer-address [payer]="payer()"></ach-payer-address>
    </div>
    <div class="footer">
      <span><button (click)="dialogClose(true)" rs-raised-button
          color="secondary">CANCEL</button></span>
      <span><button [disabled]="acknowledge()" (click)="register()" rs-raised-button color="primary">SUBMIT</button></span>
    </div>
  </div>
  }
  </div>
</rs-dialog>
